import SomaPlaceService from "./SomaPlaceServer";

const fetchInfo = () => SomaPlaceService.get("/api/v1/users/status");

const register = (data) => SomaPlaceService.post("/api/v1/users/", data);

const updateSomaPlaceUser = (data) => SomaPlaceService.put("/api/v1/users/accounts/" + data.id, data);

const fetchBanckData = () => SomaPlaceService.get("/api/v1/banks/accounts");

const fetchBanckDataUser = (data) => SomaPlaceService.get("/api/v1/banks/accounts/user/" + data.id, data);

const registerBankData = (data) => SomaPlaceService.post("/api/v1/banks/accounts", data);

const updateBankData = (data) => SomaPlaceService.put("/api/v1/banks/accounts/" + data.id, data);

const getCurrentContract = () => SomaPlaceService.get("/api/v1/contracts/current");

const contractSignature = (contractId) => SomaPlaceService.post("/api/v1/contracts/signatures", contractId);

const getContractsSignatures = () => SomaPlaceService.get("/api/v1/users/contracts");

const checkAccessSomaPlace = () => SomaPlaceService.get("/api/v1/status");

const getContractPdf = () =>
  SomaPlaceService.get("/api/v1/contracts/current/pdf", {
    method: "GET",
    responseType: "blob",
    //Force to receive data in a Blob Format
  });

const getContractPdfById = (id) =>
  SomaPlaceService.get("/api/v1/contracts/" + id + "/pdf", {
    method: "GET",
    responseType: "blob",
    //Force to receive data in a Blob Format
  });

const SomaPlace = {
  fetchInfo,
  register,
  updateSomaPlaceUser,
  fetchBanckData,
  fetchBanckDataUser,
  registerBankData,
  updateBankData,
  getCurrentContract,
  contractSignature,
  getContractsSignatures,
  getContractPdf,
  getContractPdfById,
  checkAccessSomaPlace,
};
export default SomaPlace;
